export class AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner {
    'indexName';
    'keySchema';
    'projection';
    'onDemandThroughput';
    'provisionedThroughput';
    'warmThroughput';
    'indexSizeBytes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "indexName",
            "baseName": "indexName",
            "type": "string",
            "format": ""
        },
        {
            "name": "keySchema",
            "baseName": "keySchema",
            "type": "Array<AwsDynamoDbSnapshotPropertiesLocalSecondaryIndexesInnerKeySchemaInner>",
            "format": ""
        },
        {
            "name": "projection",
            "baseName": "projection",
            "type": "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProjection",
            "format": ""
        },
        {
            "name": "onDemandThroughput",
            "baseName": "onDemandThroughput",
            "type": "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerOnDemandThroughput",
            "format": ""
        },
        {
            "name": "provisionedThroughput",
            "baseName": "provisionedThroughput",
            "type": "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerProvisionedThroughput",
            "format": ""
        },
        {
            "name": "warmThroughput",
            "baseName": "warmThroughput",
            "type": "AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInnerWarmThroughput",
            "format": ""
        },
        {
            "name": "indexSizeBytes",
            "baseName": "indexSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return AwsDynamoDbSnapshotPropertiesGlobalSecondaryIndexesInner.attributeTypeMap;
    }
    constructor() {
    }
}
